import { useState, useEffect } from "react";

const Loading = ({ text = "Loading", speed = 300 }) => {
  const [content, setContent] = useState(text);

  useEffect(() => {
    const id = window.setInterval(() => {
      setContent((content) => {
        return content === `${text}...` ? text : `${content}.`;
      });
    }, speed);
    return () => window.clearInterval(id);
  }, [text, speed]);
  return (
    <p className="title-1 flex w-full justify-center items-center">{content}</p>
  );
};

export default Loading;
